import { AppConfiguration } from "shared/types";

import ConfigProvider from "./ConfigProvider";
import GlobalsProvider from "./GlobalsProvider";
import useGlobalsValue from "./useGlobalsValue";

type Props = {
  config: AppConfiguration;
};

function AppContext(props: React.PropsWithChildren<Props>) {
  const { children, config } = props;

  const globalsValue = useGlobalsValue(config);

  return (
    <ConfigProvider config={config}>
      <GlobalsProvider {...globalsValue}>{children}</GlobalsProvider>
    </ConfigProvider>
  );
}

export default AppContext;
